import { render, staticRenderFns } from "./DialogContentPrintQuotes.vue?vue&type=template&id=6287ca1a&scoped=true&"
import script from "./DialogContentPrintQuotes.vue?vue&type=script&lang=js&"
export * from "./DialogContentPrintQuotes.vue?vue&type=script&lang=js&"
import style0 from "./DialogContentPrintQuotes.vue?vue&type=style&index=0&id=6287ca1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287ca1a",
  null
  
)

export default component.exports